import { render } from "./MetricCardShares.vue?vue&type=template&id=1a69afc3&scoped=true&ts=true"
import script from "./MetricCardShares.vue?vue&type=script&lang=ts"
export * from "./MetricCardShares.vue?vue&type=script&lang=ts"

import "./MetricCardShares.vue?vue&type=style&index=0&id=1a69afc3&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a69afc3"]])

export default __exports__